import usePageTitle from "../../hooks/usePageTitle";

export default function TermsOfService() {
  usePageTitle("Публичная оферта – СобеседникИИ");
  return (
    <div className="w-full px-[24px] pt-[40px] md:pt-[60px] pb-[40px] md:pb-[140px]">
      <div className="max-w-[995px] w-full mx-auto flex flex-col gap-[40px]">
        <h1 className="font-semibold text-[20px] md:text-[32px] leading-[24px] md:leading-[40px] text-center font-legal">
          Публичная оферта
        </h1>

        <div className="legal">
          <section>
            <h2>1. Общие положения</h2>
            <p>
              1.1. Сервис СобеседникИИ (далее – Сервис) – программное
              обеспечение для ЭВМ, производимое Правообладателем (далее –
              Программа); дополнительные программные модули к Программе,
              производимые Правообладателем, приобретенные или арендуемые;
              веб-сайты (sobesednikai.ru, api.sobesednikai.ru), страницы
              Правообладателя в социальных сетях, производимые Правообладателем,
              приобретенные или арендуемые; оборудование (ЭВМ и сетевое
              оборудование), приобретенное или арендуемое Правообладателем;
              служебное программное обеспечение, производимое Правообладателем,
              приобретенное или арендуемое; программные библиотеки, производимые
              Правообладателем, приобретенные или арендуемые;
              фото/аудио/видео/материалы о Программах и веб-сайтах
              Правообладателя, информационные письма, отсылаемые Пользователю на
              электронный почтовый ящик, и иные службы, обеспечивающие
              функционирование Программы, дополнительных программных модулей к
              Программе, веб-сайтов Правообладателя, оборудования
              Правообладателя, служебного программного обеспечения и программных
              библиотек.
              <br />
              1.2. Редакция Сервиса – подмножество функционала Сервиса, которое
              может быть использовано в Программе, на конкретном подмножестве
              платформ (Android, iOS). Каждая Редакция Сервиса представлена
              набором всех возможных кортежей («Функция Сервиса»; «Программа»;
              «Платформа»), каждый из которых имеет одно значение из двух
              возможных: «разрешено» или «запрещено». Например, один из кортежей
              Бесплатной Редакции Сервиса имеет вид: (1 день бесплатного
              использования сервиса), значение кортежа – запрещено; это
              означает, что Пользователь, получив неисключительные права на
              использование Бесплатной Редакции Сервиса, не имеет возможности
              использовать приложение бесплатно «СобеседникИИ» на платформе
              iOS/Android. Количество Редакций Сервиса, а также значения всех
              возможных кортежей («функция Сервиса»; «Программа»; «платформа»)
              для каждой Редакции Сервиса устанавливаются Правообладателем и
              публикуются на веб-сайтах Сервиса.
              <br />
              1.3. Лицензируемый пользователь – физическое лицо, юридическое
              лицо, индивидуальный предприниматель, орган государственной власти
              или государственная организация, которая получила неисключительные
              права на использование Сервиса.
              <br />
              1.4. Период использования Сервиса – период, на который передаются
              неисключительные права на использование конкретной Редакции
              Сервиса конкретным количеством лицензируемых пользователей.
              <br />
              1.5. Аккаунт – возможность использовать конкретную Редакцию
              Сервиса конкретным количеством лицензируемых пользователей в
              течение конкретного периода использования Сервиса. Данная
              возможность предоставляется Пользователю с конкретными
              авторизационными данными.
              <br />
              1.6. Авторизационные данные – адрес электронной почты и пароль,
              используемые Пользователем для доступа к функционалу Сервиса.
              <br />
              1.7. Активация аккаунта – предоставление Пользователю (с
              конкретными авторизационными данными) возможности использовать
              конкретную Редакцию Сервиса конкретным количеством лицензируемых
              пользователей в течение конкретного периода использования Сервиса.
              <br />
              1.8. Электронные каналы связи – системы коммуникации,
              функционирующие посредством использования сети Интернет. Включают
              в себя: электронную почту, системы мгновенного обмена сообщениями,
              систему обмена информацией между Программами и веб-серверами
              Правообладателя (данная система используется для доставки
              различных уведомлений в Программы, в частности уведомлений о
              выпуске новых версий Программ, а также для обмена служебной
              информацией в целях улучшения качества Сервиса).
              <br />
              1.9. Партнер Правообладателя – физическое лицо, либо
              индивидуальный предприниматель, либо юридическое лицо, получившее
              от правообладателя неисключительные права на распространение услуг
              Сервиса и/или оказание дополнительных услуг, связанных с Сервисом
              (в частности осуществление консультаций, обучение пользованию,
              помощь в установке и настройке Программ и выполнение сервисного
              обслуживания Программ).
            </p>
          </section>

          <section>
            <h2>2. Предмет Договора</h2>
            <p>
              2.1. Правообладатель обязуется предоставить Пользователю (напрямую
              либо через третьих лиц) неисключительные права на использование
              Сервиса в соответствии с установленными Договором правилами и
              условиями (простую (неисключительную) лицензию).
              <br />
              2.2. ООО "НЕЙРОПРОДАКШН" является обладателем интеллектуальных
              прав (как исключительного права, так и личных неимущественных
              прав, включая право авторства) на Сервис.
              <br />
              2.3. Правообладатель, при условии волеизъявления Пользователя и
              одновременно с этим при наличии у Правообладателя возможности,
              обязуется оказать Пользователю (напрямую либо через третьих лиц)
              дополнительные услуги, связанные с Сервисом, в частности
              осуществление консультаций, обучение пользованию, помощь в
              установке и настройке Программ и выполнение сервисного
              обслуживания Программ. Стоимость каждой дополнительной услуги
              устанавливается Правообладателем; в случае если дополнительные
              услуги оказываются третьим лицом, стоимость каждой дополнительной
              услуги устанавливается третьим лицом. Дополнительные услуги могут
              оказываться Пользователю на безвозмездной основе.
            </p>
          </section>

          <section>
            <h2>3. Условия акцепта Договора</h2>
            <p>
              3.1. Договор считается акцептованным Пользователем в случае
              соблюдения хотя бы одного из трех следующих условий:
              <span>
                1. Запуск Пользователем установки Программы (Правообладатель или
                Партнер Правообладателя в рамках предоставления дополнительных
                услуг может установить Программу на ЭВМ Пользователя после
                получения от Пользователя соответствующей просьбы).
              </span>
              <span>
                2. Оплата Пользователем неисключительных прав на использование
                Сервиса.
              </span>
              <span>
                3. Создание Пользователем аккаунта (Правообладатель может
                создать аккаунт для Пользователя после получения от Пользователя
                соответствующей просьбы).
              </span>
            </p>
          </section>

          <section>
            <h2>
              4. Порядок передачи и стоимость неисключительных прав на
              использование Сервиса
            </h2>
            <p>
              4.1. Стоимость неисключительных прав на использование Сервиса
              устанавливаются Правообладателем и публикуется на веб-сайтах
              Сервиса.
              <br />
              4.2. Стоимость неисключительных прав на использование Сервиса
              зависит от Редакции Сервиса, количества лицензируемых
              пользователей и периода использования Сервиса.
              <br />
              4.3. Сумма вознаграждения Правообладателя за предоставление
              неисключительных прав на использование Сервиса не облагается НДС,
              в соответствии со статьей 149, пунктом 2, подпунктом 26 Налогового
              кодекса Российской Федерации.
              <br />
              4.4. Порядок передачи неисключительных прав на использование
              Сервиса
              <br />
              4.4.1. Порядок передачи неисключительных прав на использование
              Бесплатной Редакции Сервиса
              <br />
              4.4.1.1. Порядок:
              <span>- Пользователь создает аккаунт.</span>
              <span>- Правообладатель активирует аккаунт.</span>
              4.4.1.2. Моментом приобретения Пользователем неисключительных прав
              на использование Сервиса считается момент активации
              Правообладателем аккаунта.
              <br />
              4.4.2. Порядок передачи неисключительных прав на использование
              Редакции Сервиса, отличной от Бесплатной
              <br />
              неисключительных прав на использование Редакции Сервиса, отличной
              от Бесплатной
              <br />
              4.4.2.1. Порядок возмездной передачи неисключительных прав на
              использование Сервиса
              <br />
              4.4.2.1.1. Порядок:
              <span>
                - Пользователь выбирает требующийся период использования
                Сервиса. Количество периодов использования Сервиса, доступных
                для выбора, а также длительность каждого периода устанавливаются
                Правообладателем и публикуются на сайте Сервиса и приложении.
              </span>
              <span>
                - Пользователь оплачивает неисключительные права на
                использование Сервиса. Оплата возможна в приложении
                Правообладателя. Допускается частичная оплата неисключительных
                прав на использование Сервиса (оплата долями в течение
                определенного промежутка времени) при условии, что до момента
                оплаты Сторонами достигнута договоренность о возможности и
                условиях частичной оплаты.
              </span>
              <span>
                - Правообладатель (либо Партнер Правообладателя) получает
                денежные средства.
              </span>
              <span>
                - Правообладатель активирует аккаунт. Правообладатель
                посредством электронных каналов связи высылает Пользователю
                уведомление об активации аккаунта.
              </span>
              4.4.2.1.2. Порядок: Моментом приобретения Пользователем
              неисключительных прав на использование Сервиса считается момент
              активации Правообладателем аккаунта.
              <br />
              4.4.2.2. Порядок безвозмездной передачи неисключительных прав на
              использование Сервиса
              <br />
              4.4.2.2.1. Порядок:
              <span>
                - Пользователь выполняет условия безвозмездного получения
                неисключительных прав на использование Сервиса. Возможность
                безвозмездного получения, а также условия получения, включая
                Редакцию Сервиса, период использования Сервиса, устанавливаются
                Правообладателем и публикуются на сайте Сервиса или приложении.
              </span>
              <span>
                - Пользователь сообщает Правообладателю адрес электронной почты
                для создания аккаунта (если Пользователь еще не создал аккаунт)
                или активации аккаунта (если Пользователь уже создал аккаунт).
              </span>
              <span>
                - Правообладатель создает аккаунт для Пользователя, используя
                полученный от Пользователя адрес электронной почты, и
                посредством электронных каналов связи высылает Пользователю
                авторизационные данные (в случае, если Пользователь еще не
                создал аккаунт).
              </span>
              <span>
                - Правообладатель активирует аккаунт. Правообладатель
                посредством электронных каналов связи высылает Пользователю
                уведомление об активации аккаунта.
              </span>
              4.4.2.2.2. Моментом приобретения Пользователем неисключительных
              прав на использование Сервиса считается момент активации
              Правообладателем аккаунта.
              <br />
              4.5. Период, на который передаются неисключительные права на
              использование Сервиса
              <br />
              4.5.1. В случае, если Пользователь получил неисключительные права
              на использование Бесплатной Редакции Сервиса
              <br />
              4.5.1.1. Неисключительные права на использование Бесплатной
              Редакции Сервиса передаются на неограниченный период (дата
              окончания периода не определена).
              <br />
              4.5.2. В случае, если Пользователь получил неисключительные права
              на использование Редакции Сервиса, отличной от Бесплатной
              <br />
              4.5.2.1. Неисключительные права на использование Редакции Сервиса,
              отличной от Бесплатной, передаются на ограниченный период.
              <br />
              4.5.2.2. Пользователь в любой момент времени (как до, так и после
              истечения периода использования Сервиса) может получить
              дополнительный период использования Сервиса, период является
              ограниченным. Получение дополнительного периода использования
              Сервиса осуществляется в порядке, изложенном в разделе 4.4.2.
              Оплата дополнительного периода возможна в приложении
              Правообладателя. Стоимость дополнительного периода, количество
              дополнительных периодов, доступных для выбора, длительность
              каждого дополнительного периода, а также порядок расчета новой
              даты окончания периода использования Сервиса устанавливаются
              Правообладателем и публикуются на сайте Сервиса и в приложении.
              <br />
              4.5.2.3. Сумма вознаграждения Правообладателя за предоставление
              дополнительного периода использования Сервиса не облагается НДС, в
              соответствии со статьей 149, пунктом 2, подпунктом 26 Налогового
              кодекса Российской Федерации, а также в соответствии с тем, что
              предоставление дополнительного периода использования Сервиса – это
              предоставление Пользователю неисключительных прав на использование
              Сервиса конкретным количеством лицензируемых пользователей в
              течение конкретного периода.
              <br />
              4.5.2.4. После окончания периода использования Сервиса происходит
              следующее: конкретный набор кортежей («функция Сервиса»;
              «Программа»; «платформа») меняет свое значение с «разрешено» на
              «запрещено». Таким образом Редакция Сервиса переходит в режим
              ограниченной функциональности. Для каждой Редакции Сервиса
              определен набор кортежей («функция Сервиса»; «Программа»;
              «платформа»), меняющих свое значение с «разрешено» на «запрещено»
              при включении режима ограниченной функциональности; данные наборы
              устанавливаются Правообладателем и публикуются на веб-сайтах
              Сервиса.
              <br />
              4.6. Стоимость оказанных услуг (неисключительных прав на
              использование Сервиса) и их содержание являются твердыми и не
              подлежат изменению в течение всего срока использования Сервиса
              (оплаченного периода использования Сервиса).
            </p>
          </section>

          <section>
            <h2>
              5. Правила предоставления неисключительных прав на использование
              Сервиса на условиях Услуги Подписки на Сервис
            </h2>
            <p>
              5.1. Услуга Подписка на Сервис – означает бессрочную услугу
              (действующую до момента отказа Пользователя от нее) по
              предоставлению Правообладателем Пользователю за периодическую
              абонентскую плату возможности доступа к Сервису в соответствии с
              правилами, ограничениями и техническими требованиями, указанными в
              настоящих Условиях. Период подписки, её стоимость и срок действия
              каждой Редакции Сервиса устанавливаются Правообладателем и
              публикуются на сайте Сервиса и/или в приложении. Текущие тарифы на
              использование Сервиса:
              <span>- 1 месяц — 500 (пятьсот) рублей;</span>
              <span>- 3 месяца — 1 300 (одна тысяча триста) рублей;</span>
              <span>- 12 месяцев — 4 500 (четыре тысячи пятьсот) рублей.</span>
              Указанные тарифы могут быть изменены Правообладателем в порядке,
              установленном пунктом 5.7 настоящего Договора. Актуальные цены
              публикуются на веб-сайте и в приложении Сервиса.
              <br />
              5.2. Начало действия данной Услуги исчисляется с момента внесения
              первого абонентского платежа Пользователем и отражения факта
              оплаты Услуги в электронной системе учета платежей
              Правообладателя. Пользователь вправе в любое время отказаться от
              дальнейшего пользования данной Услугой в порядке, предусмотренном
              пунктом 5.6 настоящих Условий.
              <br />
              5.3. При первоначальном заказе и оплате Услуги Подписки на Сервис
              Пользователь разрешает Правообладателю взимать за данную Услугу
              установленную Правообладателем на день оплаты абонентскую плату до
              момента отказа Пользователя от дальнейшего пользования данной
              Услугой. Пользователь понимает и соглашается с тем, что стоимость
              абонентской платы за Услугу Подписки на Сервис может взиматься
              ежемесячно или ежегодно или в ином порядке, как будет определено
              при первоначальном заказе и оплате данной Услуги Пользователем.
              Пользователь понимает и соглашается с тем, что Услуга Подписки на
              Сервис действует бессрочно и может быть прекращена в любой момент
              путём отказа Пользователя от дальнейшего пользования данной
              Услугой в порядке, предусмотренном в пункте 5.6 настоящих Условий,
              либо по иным основаниям, предусмотренным настоящими Условиями.
              Отказ от оплаты Пользователем абонентской платы за соответствующий
              период оказания Услуги Подписки на Сервис является отказом
              Пользователя от дальнейшего пользования данной Услугой; в таком
              случае доступ Пользователя к Сервису в рамках данной Услуги
              прекращается со дня, следующего за последним днем оплаченного
              периода оказания Услуги Подписки на Сервис. Списание денежных
              средств за следующий месяц (или иной период, определенный при
              первоначальном заказе и оплате Услуги Подписки на Сервис) оказания
              Услуги Подписки на Сервис производится Правообладателем не ранее,
              чем за 24 (двадцать четыре) часа до окончания текущего месяца
              действия Услуги. Конкретное время списания определяется системой
              оплаты в зависимости от времени первой оплаты подписки.
              <br />
              5.4. Информация о следующем списании стоимости Услуги Подписки на
              Сервис указывается в разделе «Подписка» в приложении Сервиса.
              <br />
              5.5. В случае если на Личном счете/банковской карте, указанных
              Пользователем при оплате Услуги Подписки на Сервис, на день оплаты
              недостаточно средств для оплаты абонентской платы за следующий
              период действия данной Услуги, действие Услуги Подписки на Сервис
              прекращается со дня, следующего за последним днем оплаченного
              периода.
              <br />
              5.6. Пользователь может в любое время отказаться от Услуги
              Подписки на Сервис. Для этого Пользователь должен нажать на кнопку
              «Отменить подписку» в разделе «Подписка» в приложении Сервиса и
              следовать дальнейшим инструкциям, представленным в Сервисе.
              Действие Услуги Подписки на Сервис для данного Пользователя
              прекращается со дня, следующего за последним днем оплаченного
              периода; списания денежных средств с Личного счета/банковской
              карты Пользователя за следующий период действия данной Услуги не
              производится.
              <br />
              5.6.1. Возврат уплаченных денежных средств за текущий оплаченный
              период подписки не производится, за исключением случаев ошибочного
              списания или технического сбоя. В случае ошибочного списания
              возврат осуществляется в течение 10 (десяти) рабочих дней с
              момента подтверждения факта избыточного списания. Возврат
              производится тем же способом, которым была осуществлена оплата.
              <br />
              5.7. Стоимость Услуг, их содержание, сроки и порядок оплаты могут
              быть в одностороннем порядке изменены Правообладателем. При
              изменении стоимости подписки Правообладатель уведомляет
              Пользователя за 10 (десять) календарных дней до вступления новых
              тарифов в силу посредством электронных каналов связи. В случае
              несогласия с изменением стоимости Пользователь вправе отказаться
              от подписки в порядке, установленном пунктом 5.6 настоящего
              Договора.
              <br />
              5.8. Стоимость Услуги Подписки на Сервис указывается
              Правообладателем на сайте Сервиса и в приложении с предложением о
              предоставлении такой Услуги.
              <br />
              5.9. Автопродление Услуги Подписки на Сервис осуществляется на тот
              же срок, который был выбран Пользователем при первоначальном
              приобретении Услуги Подписки на Сервис, и по той же стоимости, за
              которую была первоначально приобретена Услуга Подписки на Сервис,
              если Пользователь заблаговременно не поменяет Условия Подписки на
              Сервис или не откажется от Услуги Подписки на Сервис. При
              продлении Услуги на Сервис цена подписки может изменяться. В этом
              случае информация о новой цене подписки будет включена в
              уведомление, отправленное по электронной почте, связанной с
              аккаунтом Пользователя. Информация о следующем списании стоимости
              Услуги Подписки на Сервис указывается в разделе «Подписка» в
              приложении Сервиса.
            </p>
          </section>

          <section>
            <h2>6. Обновление Программ</h2>
            <p>
              6.1. Добавление нового функционала в Программы, а также
              исправление найденных в Программах ошибок и недоработок
              осуществляется путем выпуска новых версий Программ.
              <br />
              6.2. Периодичность выпуска новых версий Программ устанавливается
              Правообладателем.
              <br />
              6.3. При выпуске новых версий Программ Правообладатель оповещает
              Пользователя посредством электронных каналов связи.
              <br />
              6.4. Обновление новых версий Программ Пользователь выполняет
              самостоятельно. Правообладатель или Партнер Правообладателя в
              рамках предоставления дополнительных услуг может установить новые
              версии Программ на ЭВМ Пользователя после получения от
              Пользователя соответствующей просьбы.
            </p>
          </section>

          <section>
            <h2>7. Права и обязанности сторон</h2>
            <p>
              7.1. Права Пользователя
              <br />
              7.1.1. Безвозмездно использовать
              <span>
                - Полный функционал Бесплатной Редакции Сервиса в течение
                ограниченного периода (дата окончания периода определена и
                публикуется на сайте и в приложении Правообладателя).
              </span>
              7.1.2. Изменять Редакцию Сервиса.
              <br />
              7.1.2.1. В случае, если используемая Редакция Сервиса изменяется
              на Бесплатную
              <br />
              7.1.2.1.1. Изменение используемой Редакции Сервиса на Бесплатную
              производится на безвозмездной основе. Правообладатель и
              Пользователь не осуществляют каких-либо взаиморасчетов (денежных и
              иных) при изменении Редакции Сервиса на Бесплатную.
              <br />
              7.1.2.1.2. Для изменения используемой Редакции Сервиса на
              Бесплатную Пользователь должен направить Правообладателю просьбу
              посредством электронных каналов связи.
              <br />
              7.1.2.1.3. После изменения используемой Редакции Сервиса на
              Бесплатную Правообладатель отзывает неисключительные права на
              использование Редакции Сервиса, которую пользователь заменял.
              <br />
              7.1.2.2. В случае, если используемая Редакция Сервиса изменяется
              на Редакцию, отличную от Бесплатной
              <br />
              7.1.2.2.1. Для изменения используемой Редакции Сервиса
              Пользователь должен получить неисключительные права на
              использование требующейся Редакции Сервиса конкретным количеством
              лицензируемых пользователей в течение конкретного периода
              использования Сервиса. Получение неисключительных прав на
              использование Сервиса осуществляется в порядке и на условиях,
              изложенных в разделах 4.1, 4.2, 4.3, 4.4. Длительность периода, на
              который передаются неисключительные права на использование
              Сервиса, и условия продления периода излагаются в разделе 4.5.
              <br />
              7.1.2.2.2. После изменения используемой Редакции Сервиса на
              Редакцию, отличную от Бесплатной, Правообладатель отзывает
              неисключительные права на использование Редакции, которую
              пользователь заменял. Если Пользователь заменяет Бесплатную
              Редакцию на какую-либо другую Редакцию, то Правообладатель не
              отзывает неисключительные права на использование Бесплатной
              Редакции.
              <br />
              7.1.2.2.3. Правообладатель может установить скидку на замену
              конкретной Редакции Сервиса на конкретную Редакцию. Возможность
              применения скидки и размер скидки устанавливаются Правообладателем
              и публикуются на веб-сайтах Сервиса.
              <br />
              7.1.3. Использовать Сервис на любом количестве ЭВМ.
              <br />
              7.1.4. Отказаться от использования Сервиса.
              <br />
              7.1.4.1. Для отказа от использования Сервиса Пользователь
              расторгает Договор в одностороннем порядке.
              <br />
              7.1.4.2. Порядок расторжения Договора изложен в разделе 13.
              <br />
              7.1.4.3. Условия компенсации и возмещения затрат при расторжении
              Договора изложены в разделе 12.
              <br />
              7.2. Обязанности Пользователя
              <br />
              7.2.1. Использовать Сервис только в пределах прав, которые
              предусмотрены в Договоре.
              <br />
              7.2.2. Осуществлять оплату по Договору, за исключением случаев,
              когда Пользователь получает на безвозмездной основе
              неисключительные права на использование Сервиса, дополнительный
              период использования Сервиса, а также дополнительные услуги,
              связанные с Сервисом.
              <br />
              7.2.3. Хранить информацию о каждом перечислении денежных средств
              Правообладателю и Партнерам Правообладателя:
              <span>- Дату перечисления денежных средств.</span>
              <span>- Сумму перечисленных денежных средств.</span>
              <span>
                - Приложение, на котором был начат процесс перечисления денежных
                средств, и email, который был указан пользователем в процессе
                перечисления денежных средств.
              </span>
              <span>
                - Номер счета на оплату (в случае, если денежные средства были
                перечислены безналичным банковским переводом и счет на оплату
                был выставлен Правообладателем).
              </span>
              <span>
                - Номер счета на оплату и реквизиты Партнера Правообладателя:
                наименование юридического лица либо фамилию, имя, отчество
                индивидуального предпринимателя (в случае, если денежные
                средства были перечислены безналичным банковским переводом и
                счет на оплату был выставлен Партнером Правообладателя).
              </span>
              7.2.4. Пользователь обязуется незамедлительно прекратить
              использование Сервиса при наличии у него состояния, требующего
              профессиональной медицинской или психологической помощи.
              <br />
              7.3. Права Правообладателя
              <br />
              7.3.1. Изменять все характеристики Сервиса, в частности:
              <span>
                - Стоимость получения неисключительных прав на использование
                Сервиса.
              </span>
              <span>
                - Стоимость дополнительного периода использования Сервиса.
              </span>
              <span>
                - Набор Редакций Сервиса (Правообладатель может как создавать
                новые Редакции, так и упразднять существующие Редакции).
              </span>
              <span>
                - Значения кортежей («функция Сервиса»; «Программа»;
                «платформа») любой Редакции Сервиса.
              </span>
              <span>
                - Набор кортежей («функция Сервиса»; «Программа»; «платформа»),
                меняющих свое значение с «разрешено» на «запрещено» при
                включении режима ограниченной функциональности Редакции Сервиса
                (для каждой Редакции Сервиса свой набор).
              </span>
              7.3.2. Привлекать третьих лиц (Партнеров Правообладателя) для
              исполнения обязательств по Договору, включая получение денежных
              средств за неисключительные права на использование Сервиса,
              дополнительный период использования Сервиса, а также для оказания
              дополнительных услуг, связанных с Сервисом, в частности
              осуществления консультаций, обучения пользованию, помощи в
              установке и настройке Программ и выполнения сервисного
              обслуживания Программ.
              <br />
              7.3.3. Получать в автоматическом режиме (без получения согласия
              пользователя, выражаемого в явном виде) по электронным каналам
              связи следующую информацию от Пользователя: обезличенную
              статистическую информацию об использовании Программ и веб-сайтов
              Правообладателя (в частности информацию о платформе, на которой
              используются Программы и веб-сайты Правообладателя, информацию об
              установленном на платформу программном обеспечении (в частности
              информацию о веб-браузере) и программных библиотеках, информацию
              об используемом оборудовании (ЭВМ, сетевое оборудование и прочее),
              а также другую необходимую техническую информацию). Единственная
              цель, которую преследует Правообладатель при сборе информации –
              это обеспечение максимально высокого уровня обслуживания клиентов
              и повышение качества Сервиса, включая исправление ошибок в
              Программах и веб-сайтах Сервиса. Правообладатель никак не
              связывает получаемую информацию с персональными данными
              Пользователя.
              <br />
              7.3.4. Расторгнуть Договор в одностороннем порядке в случае
              нарушения Пользователем условий Договора.
              <br />
              7.4. Обязанности Правообладателя
              <br />
              7.4.1. Публиковать на веб-сайтах Сервиса требующиеся для
              корректного функционирования Сервиса:
              <span>
                - Минимальные характеристики оборудования (ЭВМ, сетевое
                оборудование и прочее).
              </span>
              <span>
                - Перечень программного обеспечения и программных библиотек,
                которые должны быть установлены на ЭВМ, а также версии
                программного обеспечения и программных библиотек из этого
                перечня.
              </span>
              7.4.2. Публиковать в приложении Сервиса минимальные версии
              платформ, на которых возможен запуск Программ.
              <br />
              7.4.3. Проводить работы по улучшению качества Сервиса. Во время
              проведения работ часть функционала Сервиса может быть недоступной
              Пользователю.
              <br />
              7.4.4. Обеспечивать функционирование Сервиса в круглосуточном
              режиме, за исключением времени проведения работ по улучшению
              качества Сервиса.
              <br />
              7.4.5. Безвозмездно предоставлять Пользователю техническую
              поддержку по электронным каналам связи и телефону (контакты
              технической поддержки и время работы публикуются на веб-сайтах
              Сервиса) в течение неограниченного периода (дата окончания периода
              не определена). При обращении Пользователя по одному из каналов
              связи Правообладатель вправе перевести Пользователя на другой
              канал (например, с телефона на электронную почту) с целью
              повышения качества технической поддержки.
              <br />
              7.4.6. Информировать Пользователя о выпуске новых версий Программ.
              Информирование производится посредством электронных каналов связи.
              7.4.7. Устранять возможное нарушение работоспособности Сервиса и
              падение производительности Сервиса.
              <br />
              7.4.8. Обеспечивать информационную безопасность данных
              Пользователя, хранимых посредством Сервиса.
              <br />
              7.4.9. Обеспечивать информационную безопасность собираемых и
              обрабатываемых персональных данных Пользователя.
            </p>
          </section>

          <section>
            <h2>8. Неправомерное использование Сервиса</h2>
            <p>
              8.1. Пользователю запрещается
              <br />
              8.1.1. Декомпилировать, дизассемблировать, модифицировать или
              выполнять производные работы, основанные на программном
              обеспечении, целиком или частично, за исключением случаев,
              предусмотренных законодательством Российской Федерации.
              <br />
              8.1.2. Вручную (то есть не используя интерфейс Программ) удалять и
              модифицировать файлы Программы, а также добавлять новые файлы за
              исключением случаев:
              <span>
                - Когда Правообладатель в явном виде дает указание выполнить эти
                действия.
              </span>
              8.1.3. Передавать неисключительные права на использование Сервиса
              третьим лицам.
              <br />
              8.1.4. Предоставлять доступ к авторизационным данным третьим лицам
              в нарушение положений Договора.
              <br />
              8.1.5. Сдавать Сервис в аренду, прокат или во временное
              пользование.
              <br />
              8.1.6. Запрещается использовать Сервис для создания, публикации,
              передачи или распространения сообщений, содержащих:
              <span>- Угрозы причинения вреда себе или третьим лицам;</span>
              <span>
                - Пропаганду самоубийства, членовредительства, насилия,
                употребления наркотических, психотропных или токсичных веществ;
              </span>
              <span>
                - Описание способов причинения вреда, совершения противоправных
                действий или побуждение к их совершению;
              </span>
              <span>
                - Просьбы о предоставлении медицинской, психологической или иной
                профессиональной помощи.
              </span>
              В случае выявления подобных сообщений доступ к Сервису может быть
              ограничен или заблокирован, а Аккаунт удалён без предварительного
              уведомления Пользователя.
              <br />
              8.2. В случае если Пользователь (либо третье лицо, получившее
              доступ к оборудованию Пользователя) совершил одно или несколько
              действий, перечисленных в разделе 8.1., и эти действия привели к
              невозможности или ограниченной возможности использования Программ
              на ЭВМ Пользователя, и/или веб-сайтов Правообладателя,
              Правообладатель имеет право:
              <span>- Расторгнуть Договор в одностороннем порядке.</span>
              <span>
                - Понизить приоритет предоставления Пользователю технической
                поддержки в пользу других Пользователей.
              </span>
              <span>
                - Предоставить Пользователю техническую поддержку на возмездной
                основе.
              </span>
            </p>
          </section>

          <section>
            <h2>9. Ответственность сторон</h2>
            <p>
              9.1. За неисполнение, ненадлежащее или несвоевременное исполнение
              обязательств по Договору Стороны несут ответственность в
              соответствии с действующим законодательством Российской Федерации.
              <br />
              9.2. Пользователь соглашается с тем, что никакие компьютерные
              системы, включая все подсистемы Сервиса, не свободны от ошибок.
              <br />
              9.3. Пользователь соглашается с тем, что для работы с Сервисом ему
              необходимо использовать программное обеспечение (веб-браузеры,
              операционные системы и прочее), программные библиотеки,
              оборудование (ЭВМ, сетевое оборудование и прочее) и услуги (в
              частности предоставление доступа к сети Интернет), производимые
              третьими лицами, и Правообладатель не может нести ответственность
              за качество их работы.
              <br />
              9.4. Пользователь соглашается с тем, что для обеспечения
              функционирования Сервиса Правообладатель может использовать
              программное обеспечение, программные библиотеки, оборудование
              (ЭВМ, сетевое оборудование и прочее) и услуги, производимые
              третьими лицами, и Правообладатель не может нести ответственность
              за качество их работы.
              <br />
              9.5. Ограниченная гарантия на работоспособность и
              производительность Сервиса
              <br />
              9.5.1. Правообладатель не дает гарантий на работоспособность и
              производительность Сервиса. Сервис поставляется по принципу «как
              есть», в соответствии с принципом «as is», общепринятым в
              международной компьютерной практике.
              <br />
              9.5.2. Правообладатель не дает гарантий на работоспособность и
              производительность дополнительных программных модулей к
              Программам, если они произведены не Правообладателем и
              одновременно с этим Правообладатель не приобрел модули и не
              арендовал их. 8.2. В случае если Пользователь (либо третье лицо,
              получившее доступ к оборудованию Пользователя) совершил одно или
              несколько действий, перечисленных в разделе 8.1., и эти действия
              привели к невозможности или ограниченной возможности использования
              Программ на ЭВМ Пользователя, и/или веб-сайтов Правообладателя,
              Правообладатель имеет право:
              <span>
                - За любые действия Пользователя, связанные с использованием
                предоставленных неисключительных прав на использование Сервиса.
              </span>
              <span>
                - За убытки (в частности убытки в связи с недополученной
                коммерческой прибылью, упущенной выгодой, прерыванием
                деятельности, утратой информации), понесенные Пользователем в
                связи с использованием предоставленных неисключительных прав на
                использование Сервиса (в частности с использованием Сервиса,
                частичным или полным нарушением работоспособности Сервиса,
                падением производительности Сервиса), в связи с установкой или
                невозможностью установки Программ, в связи с созданием или
                невозможностью создания аккаунта, в связи с оказанием
                Правообладателем (или Партнерами Правообладателя) дополнительных
                услуг, связанных с Сервисом.
              </span>
              <span>
                - Предоставить Пользователю техническую поддержку на возмездной
                основе.
              </span>
              <span>
                - За убытки (в частности убытки в связи с недополученной
                коммерческой прибылью, упущенной выгодой, прерыванием
                деятельности, утратой информации), понесенные Пользователем,
                если по вине Пользователя произошла утеря, разглашение, кража
                авторизационных данных.
              </span>
              9.6. Сервис не предоставляет медицинских, психологических,
              реабилитационных и иных консультаций. Все результаты работы
              Сервиса носят информационный и развлекательный характер, не
              являются рекомендациями, предупреждениями, инструкциями и не могут
              рассматриваться как профессиональная помощь.
              <br />
              9.7. Правообладатель не несет ответственности за сообщения
              Пользователя, включая сообщения, связанные с угрозами жизни и
              здоровью, призывами к насилию, самоубийству, причинению вреда себе
              или третьим лицам.
            </p>
          </section>

          <section>
            <h2>10. Блокирование и удаление Аккаунта и/или данных Аккаунта</h2>
            <p>
              10.1. Правообладатель имеет право на блокирование и/или удаление
              Аккаунта, а также данных Аккаунта в случаях, порядке и на
              условиях, предусмотренных настоящими Условиями.
              <br />
              10.2. Блокирование Аккаунта означает временную невозможность
              использования Пользователем Услуг независимо от Редакции Сервиса
              при возможности доступа (с ограниченной возможностью) Пользователя
              к Сервису. Блокирование Аккаунта осуществляется Правообладателем
              до момента устранения Пользователем нарушений, приведших к
              блокированию Аккаунта, если иное не предусмотрено настоящими
              Условиями.
              <br />
              10.3. Удаление Аккаунта означает невозможность доступа
              Пользователя к Сервису и невозможность использования Услуг в
              рамках соответствующего Аккаунта независимо от Редакции Сервиса.
              <br />
              10.4. При блокировании или удалении Аккаунта происходит
              прекращение доступа Пользователя к Сервису, с одновременным
              выводом соответствующего предупреждения, оформленного с
              применением графических и иных элементов дизайна Сервиса
              СобеседникИИ в соответствии с настоящими Условиями.
              <br />
              10.5. Правообладатель имеет право на блокирование Аккаунта в
              следующих случаях:
              <br />
              10.5.1. При нарушении Пользователем настоящих Условий;
              <br />
              10.5.2. При использовании бесплатной Редакции Сервиса до момента
              оплаты Пользователем неисключительных прав на использование
              Редакции Сервиса с соблюдением условий о количестве лицензируемых
              пользователей и периоде использования Сервиса.
              <br />
              10.5.3. При введении Пользователем неверных данных, невведении
              Пользователем данных, запрашиваемых при создании Аккаунта,
              несвоевременной актуализации данных Пользователя.
              <br />
              10.5.4. При непредставлении подтверждающих документов, при этом к
              вышеуказанным действиям приравнивается бездействие Пользователя в
              течение 3 (трех) календарных дней с момента направления
              Правообладателем соответствующего запроса и/или требования.
              <br />
              10.5.5. В случае получения Правообладателем жалобы/требования от
              третьих лиц и/или требования от компетентных органов, в отношении
              действий и/или бездействия Пользователя, в том числе по поводу
              нарушения авторских прав и прочих нарушений настоящих Условий или
              требований действующего законодательства РФ – до момента
              устранения допущенных нарушений.
              <br />
              10.6. Правообладатель имеет право на удаление данных Аккаунта в
              следующих случаях:
              <br />
              10.6.1. В случае если в течение 180 (ста восьмидесяти) календарных
              дней с момента создания Аккаунта Пользователь не использует
              Сервис;
              <br />
              10.7. Правообладатель имеет право на удаление Аккаунта в следующих
              случаях:
              <br />
              10.7.1. По собственному желанию Пользователя либо при
              одностороннем отказе Пользователя от исполнения настоящих Условий;
              <br />
              10.7.2. В случае блокирования Аккаунта более трех раз;
              <br />
              10.7.3. При грубом нарушении Пользователем настоящих Условий либо
              при отказе Пользователя от устранения допущенных нарушений, либо
              при не устранении нарушений Пользователем в течение 3 (трех)
              календарных дней с момента направления Правообладателем требования
              об устранении таких нарушений;
              <br />
              10.7.4. В случае если Пользователь в течение 90 (девяноста)
              календарных дней с момента перехода на использование Бесплатной
              Редакции Сервиса не осуществит оплату неисключительных прав на
              использование Редакции Сервиса с соблюдением условий о количестве
              лицензируемых пользователей и периоде использования;
              <br />
              10.7.5. В случае если в течение 180 (ста восьмидесяти) календарных
              дней с момента создания Аккаунта Пользователь не использует
              Сервис;
              <br />
              10.7.6. В случае если с момента последнего использования
              Пользователем любой Редакции Сервиса прошло более 90 (девяноста)
              дней;
              <br />
              10.7.7. В случае обнаружения Правообладателем самостоятельно либо
              по жалобам/запросам/требованиям третьих лиц нарушений п. 8.1.1, п.
              8.1.2, п. 8.1.3, п. 8.1.4, п. 8.1.5.
              <br />
              10.8. Одновременно с удалением Аккаунта в соответствии с
              настоящими Условиями Правообладатель расторгает договор в
              одностороннем порядке.
              <br />
              10.9. В случае очевидного, с точки зрения Правообладателя,
              нарушения Пользователем законодательства РФ, использование любой
              Редакции Сервиса может быть приостановлено, а Аккаунт заблокирован
              и/или удален без предварительного предупреждения со стороны
              Правообладателя.
            </p>
          </section>

          <section>
            <h2>11. Обстоятельства непреодолимой силы</h2>
            <p>
              11.1. Стороны освобождаются от ответственности за частичное или
              полное неисполнение своих обязательств по Договору, если их
              исполнению препятствуют чрезвычайные и непреодолимые при данных
              условиях обстоятельства непреодолимой силы.
              <br />
              11.2. Под обстоятельствами непреодолимой силы понимаются такие
              обстоятельства как: стихийные бедствия, аварии, пожары, массовые
              беспорядки, забастовки, военные действия, противоправные действия
              третьих лиц, вступление в силу законодательных актов,
              правительственных постановлений и распоряжений государственных
              органов, прямо или косвенно запрещающих указанные в Договоре виды
              деятельности, повлекшие за собой невозможность выполнения
              Сторонами части или полного объема своих обязательств по Договору.
              <br />
              11.3. При возникновении обстоятельств непреодолимой силы,
              препятствующих исполнению обязательств по Договору одной из
              Сторон, она обязана оповестить другую Сторону незамедлительно
              после возникновения таких обстоятельств (если отсутствует связь,
              то незамедлительно после восстановления связи) и предпринять все
              усилия для скорейшей ликвидации последствий обстоятельств
              непреодолимой силы. Исполнение обязательств по Договору
              переносится на момент окончания ликвидации последствий
              обстоятельств непреодолимой силы.
              <br />
              11.4. Сторона, понесшая убытки в связи с обстоятельствами
              непреодолимой силы, может потребовать от стороны, ставшей объектом
              действия непреодолимой силы, документальное подтверждение о
              масштабах произошедших событий, а также об их влиянии.
            </p>
          </section>

          <section>
            <h2>12. Условия компенсации и возмещения затрат</h2>
            <p>
              12.1. Правообладатель не осуществляет частичное или полное
              возмещение затрат Пользователя (ч.1 ст. 1259 ГК РФ) на
              приобретение неисключительных прав на использование Сервиса,
              приобретение дополнительного периода использования Сервиса,,
              приобретение дополнительных услуг, связанных с Сервисом (в
              частности консультаций, обучения пользованию, помощи в установке и
              настройке Программ, выполнения сервисного обслуживания Программ),
              а также других затрат, понесенных Пользователем в связи с
              использованием предоставленных неисключительных прав на
              использование Сервиса (в частности с использованием Сервиса,
              частичным или полным нарушением работоспособности Сервиса,
              падением производительности Сервиса), в связи с установкой или
              невозможностью установки Программ, в связи с созданием или
              невозможностью создания аккаунта.
              <br />
              12.2. Правообладатель не осуществляет частичное или полное
              возмещение убытков (в частности убытков в связи с недополученной
              коммерческой прибылью, упущенной выгодой, прерыванием
              деятельности, утратой информации), понесенных Пользователем в
              связи с приобретением неисключительных прав на использование
              Сервиса, приобретением дополнительного периода использования
              Сервиса, приобретением дополнительных услуг, связанных с Сервисом
              (в частности консультаций, обучения пользованию, помощи в
              установке и настройке Программ, выполнения сервисного обслуживания
              Программ), а также других убытков, понесенных Пользователем в
              связи с использованием предоставленных неисключительных прав на
              использование Сервиса (в частности с использованием Сервиса,
              частичным или полным нарушением работоспособности Сервиса,
              падением производительности Сервиса), в связи с установкой или
              невозможностью установки Программ, в связи с созданием или
              невозможностью создания аккаунта.
            </p>
          </section>

          <section>
            <h2>13. Срок действия и порядок расторжения Договора</h2>
            <p>
              13.1. Договор вступает в силу с момента осуществления
              Пользователем акцепта Договора.
              <br />
              13.2. Договор действует в течение одного календарного года. После
              истечения календарного года действие Договора продлевается на
              очередной календарный год.
              <br />
              13.3. Любая из Сторон вправе в одностороннем порядке в любой
              момент времени расторгнуть Договор.
              <br />
              13.4. Условия компенсации и возмещения затрат при расторжении
              Договора изложены в разделе 12.
              <br />
              13.5. Порядок расторжения договора
              <br />
              13.5.1. Одна из Сторон высылает другой Стороне уведомление о
              намерении расторгнуть Договор. Уведомление должно быть выслано не
              менее чем за 10 (десять) рабочих дней до предполагаемой даты
              расторжения. Уведомление направляется посредством электронных
              каналов связи.
              <br />
              13.5.2. Сторона, принявшая уведомление, высылает ответное
              уведомление о принятии.
              <br />
              13.5.3. Правообладатель деактивирует аккаунт Пользователя и
              посредством электронных каналов связи высылает Пользователю
              уведомление о деактивации аккаунта.
              <br />
              13.5.4. Пользователь удаляет Программы со всех ЭВМ посредством
              встроенного в платформу инструмента удаления программ.
              <br />
              13.5.5. Пользователь удаляет директории, в которые были
              установлены Программы.
            </p>
          </section>

          <section>
            <h2>14. Персональные данные</h2>
            <p>
              14.1. Правообладатель выполняет все требования Федерального закона
              № 152-ФЗ «О персональных данных» в плане защиты полученных им
              персональных данных Пользователя.
              <br />
              14.2. Сервис полностью отвечает требованиям Федерального закона №
              152-ФЗ «О персональных данных».
              <br />
              14.3. Политика в отношении обработки персональных данных доступна
              по адресу: https://www.sobesednikai.ru/privacy-policy
            </p>
          </section>

          <section>
            <h2>15. Применимое законодательство. Споры</h2>
            <p>
              15.1. Договор регулируется в соответствии с законодательством
              Российской Федерации.
              <br />
              15.2. Все споры и разногласия решаются путем переговоров. В случае
              если разногласия и споры не могут быть решены путем переговоров,
              их рассмотрение передается в Арбитражный суд Ярославской области.
            </p>
          </section>

          <section>
            <h2>16. Заключительные положения</h2>
            <p>
              16.1. Содержание Договора может быть изменено Правообладателем в
              любой момент времени. Правообладатель за 10 (десять) рабочих дней
              до внесения изменений в Договор высылает Пользователю уведомление,
              содержащее перечень вносимых изменений. Уведомление направляется
              посредством электронных каналов связи. В случае если Пользователя
              не удовлетворяют вносимые изменения, он имеет право расторгнуть
              Договор в одностороннем порядке. Правообладатель не несет
              ответственности за произошедшую в результате частичного или
              полного нарушения работоспособности электронных каналов связи
              и/или падения их производительности недоставку или несвоевременную
              доставку уведомления, содержащего перечень вносимых изменений.
              <br />
              Редакция от 16.03.2023
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
